import React, { useLayoutEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import InvoiceFreeformContainer from "../../../components/Invoice/invoiceFreeformContainer";

const InvoiceFreeformPage = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <>
      <InvoiceFreeformContainer />
    </>
  );
};

export { InvoiceFreeformPage };
